import './styles.scss'

const TableRow = ({ className = '', children }) => <div className={`table__row ${className}`}>{children}</div>

export default TableRow
